import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const SYSTEM_VARIABLES = [
  { key: "{{first_name}}", label: "First Name", desc: "Customer's first name" },
  { key: "{{customer_name}}", label: "Full Name", desc: "Customer's full name" },
  { key: "{{company_name}}", label: "Company Name", desc: "Your company name" },
  { key: "{{project_address}}", label: "Project Address", desc: "Project street address" },
  { key: "{{quote_number}}", label: "Quote #", desc: "Quote number" },
  { key: "{{total}}", label: "Total", desc: "Quote total amount" },
  { key: "{{scheduled_date}}", label: "Scheduled Date", desc: "Next scheduled date" },
  { key: "{{user_name}}", label: "Your Name", desc: "Logged-in user's name" },
  { key: "{{user_first_name}}", label: "Your First Name", desc: "Logged-in user's first name" },
];

export function VariableInsertButton({ onInsert, className = "" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className={`relative inline-block ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-[#0F4C81] bg-blue-50 hover:bg-blue-100 rounded border border-blue-200 transition-colors"
        data-testid="variable-insert-btn"
      >
        <span>{"{x}"}</span>
        <span>Insert Variable</span>
        <ChevronDown className="w-3 h-3" />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-64 bg-white border border-slate-200 rounded-lg shadow-lg py-1 max-h-64 overflow-y-auto" data-testid="variable-dropdown">
          <p className="px-3 py-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider">Click to insert</p>
          {SYSTEM_VARIABLES.map((v) => (
            <button
              key={v.key}
              className="w-full text-left px-3 py-1.5 hover:bg-slate-50 flex items-center justify-between gap-2"
              onClick={() => { onInsert(v.key); setOpen(false); }}
            >
              <div>
                <span className="text-xs font-medium text-slate-700">{v.label}</span>
                <span className="text-[10px] text-slate-400 ml-1.5">{v.desc}</span>
              </div>
              <code className="text-[10px] bg-slate-100 px-1.5 py-0.5 rounded text-slate-500 font-mono flex-shrink-0">{v.key}</code>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export { SYSTEM_VARIABLES };
